import { FacebookIcon, FacebookShareButton } from "react-share";

const FacebookShare = (props) => {
  const { shareUrl } = props;
  return (
    <FacebookShareButton url={shareUrl ? shareUrl : ""}>
      <FacebookIcon size={40} borderRadius={50} />
    </FacebookShareButton>
  );
};

export default FacebookShare;
